<template>
  <v-layout row wrap>
    <v-flex xs12>
      <h3 class="offers__title">{{ agreementDisplayLabel }}</h3>
    </v-flex>
    <v-flex xs12>
      <div v-if="requestAgreementLoading"></div>
      <div v-else-if="Object.keys(agreement).length !== 0">
        <div class="offers__description" v-html="agreement.displayText"></div>
        <input type="hidden" id="leadid_token" name="universal_leadid" />
        <div v-for="(offer, index) in agreement.offers" :key="index" class="offers__option">
          <v-checkbox
            v-model="offer.selected"
            class="md-primary offers__option__checkbox"
            :id="`leadid_tcpa_disclosure_${index}`">
            <template slot="label">
              <span class="offers__option__label" v-html="offer.displayText"></span>
            </template>
          </v-checkbox>
        </div>
        <div v-if="showOptInBox" class="cellphone-opt-container">
          <div class="cellphone-opt-container__fields">
            <b>Preferred Phone Number</b>
            <v-layout wrap>
              <div class="row">
                <v-text-field
                  v-model="value.phoneNumber"
                  :rules="phoneRules"
                  @input="$emit('phoneEdited', $event)"
                  label="Phone number"
                  mask="###-###-####"
                  autocomplete="tel-national"
                  name="tel-national">
                </v-text-field>

                <v-select
                  v-model="value.phoneType"
                  label="Phone type"
                  :hide-details="true"
                  :items="phoneTypes"
                  :menu-props="{ auto: true }"
                  ref="select-input-common"/>
              </div>
            </v-layout>
          </div>
        </div>
        <div
          v-if="!showLegalTextBelowContinueButton"
          v-html="finePrintHTML"
          :class="truncatedLegalTextEnabled && isLegalTextTruncated ? 'truncatedText' : ''"
          class="offers__info"></div>
        <h2
          v-if="
            truncatedLegalTextEnabled &&
            isLegalTextTruncated &&
            !showLegalTextBelowContinueButton
          "
          @click="handleTruncateChange">
          <span>Show More ▼</span>
        </h2>
        <h2
          v-if="
            truncatedLegalTextEnabled &&
            !isLegalTextTruncated &&
            !showLegalTextBelowContinueButton
          "
          @click="handleTruncateChange">
          <span>Show Less ▲</span>
        </h2>
      </div>
      <div class="row tcpa" v-if="showTCPALegal && showOptInBox">
        <v-checkbox
          :value="acceptTCPALegal"
          @change="$emit('tcpaLegalEvent', $event)"
          :rules="legalCheckboxRules">
          <template slot="label">
            <span class="offers__option__label">
              I agree to be contacted at this phone number with the terms listed above
            </span>
          </template>
        </v-checkbox>
      </div>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  data() {
    return {
      isLegalTextTruncated: true,
      phoneTypeRules: [
        v => !!v || 'Phone type is required',
      ],
      phoneRules: [v => v.length === 0 || v.length === 10 || 'Phone must be equal 10 digits'],
      phoneTypes: ['Work', 'Mobile', 'Home'],
      legalCheckboxRules: [
        v => !!v || 'Check is required',
      ],
    };
  },
  props: {
    agreementDisplayLabel: {
      required: true,
      type: String,
    },
    agreement: {
      required: true,
      type: Object,
    },
    requestAgreementLoading: {
      required: true,
      type: Boolean,
    },
    showOptInBox: {
      required: true,
      type: Boolean,
    },
    showLegalTextBelowContinueButton: {
      required: true,
      type: Boolean,
    },
    showTCPALegal: {
      required: true,
      type: Boolean,
    },
    acceptTCPALegal: {
      required: true,
      type: Boolean,
    },
    truncatedLegalTextEnabled: {
      required: true,
      type: Boolean,
    },
    value: {
      required: true,
      type: Object,
    },
  },
  methods: {
    handleTruncateChange() {
      this.isLegalTextTruncated = !this.isLegalTextTruncated;
    },
  },
  computed: {
    finePrintHTML() {
      const legalText = this.agreement.displayFinePrint || '';
      return `<label for="leadid_tcpa_disclosure_0">${legalText}</label>`;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../../styles/vars/theme';
@import '../../../styles/vars/typography';

.offers {
  &__title {
    margin-top: 32px;
    font-family: 'Barlow Condensed', sans-serif;
    letter-spacing: 0.14px;
    font-size: 24px;
    font-weight: 400;
    text-transform: uppercase;
  }

  &__description {
    font-size: 16px;
    font-weight: 500;
    line-height: 1.75;
    margin-top: 24px;
    margin-bottom: 32px;
  }

  &__info {
    font-size: 13px;
    font-weight: 500;
    border-top: 1px solid $theme-color-gray-light;
    padding-top: 20px;
  }
  h2 {
    text-align: center;
    border-bottom: 1px solid $theme-color-gray-light;
    line-height: 0.1em;
    margin: 20px 0 20px;
    span {
      font-size: 15px;
      font-weight: 500;
      background: #fff;
      padding: 0 10px;
    }
  }

  &__option {
    &__checkbox {
      margin-top: 0px;
    }

    &__label {
      font-size: 16px;
      font-weight: 500;
      color: #2d2d2d;
      font-family: Montserrat;
    }
  }

  & .cellphone-opt-container {
    padding: 24px 0px;
    color: #2d2d2d;
    font-family: Montserrat;
    font-size: 16px;
    font-weight: 500;
    line-height: 1.75;
    &__fields {
      padding: 16px;
      font-size: 16px;
      display: inline-block;
    }
  }

  & .cellphone-opt-container {
    padding-top: 24px;
    color: #2d2d2d;
    font-family: Montserrat;
    font-size: 16px;
    font-weight: 500;
    line-height: 1.75;
    &__info {
      background-color: #dff0ff;
      display: flex;
      padding: 16px;
      font-size: 16px;

      & .info-img {
        margin-right: 16px;
        margin-top: 6px;
      }
    }

    &__continue {
      padding-top: 24px;
    }

    &__my-offers {
      padding: 24px 0 32px 0;
    }
  }
}
.truncatedText {
  overflow: hidden;
  -webkit-box-orient: vertical;
  display: -webkit-box;
  text-overflow: ellipsis;
  -webkit-line-clamp: 2;
}
.row {
  display: flex;
  width: 100%;
  justify-content: space-between;
  gap: 24px;
  margin-bottom: 5px;
  &.tcpa {
    justify-content: flex-end;
    .v-input {
      flex: 0 1 content;
    }
  }
}

@media all and (max-width: 655px) {
  .offers {
    &__info {
      padding-top: 10px;
    }
  }
}
</style>
